export default __webpack_public_path__ + "c994c464941e4382d7696d42653dfaa5.svg";